import { render, staticRenderFns } from "./Curp.vue?vue&type=template&id=1cc1bbf1&scoped=true&"
import script from "./Curp.vue?vue&type=script&lang=js&"
export * from "./Curp.vue?vue&type=script&lang=js&"
import style0 from "./Curp.vue?vue&type=style&index=0&id=1cc1bbf1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc1bbf1",
  null
  
)

export default component.exports